import { createStore, applyMiddleware, compose } from "redux";
import { persistStore } from "redux-persist";
// import { createLogger } from "redux-logger";
import LogRocket from "logrocket";

//reducers and other components
import allReducers from "./reducers";

let store;

// const logger = createLogger({
// 	predicate: (state, action) => {
// 		// const someCondition = action.type === "SET_FLEET" || action.type === "AIRCRAFT_UPDATE";
// 		const someCondition = false;
// 		return someCondition;
// 	},
// 	collapsed: true
// });

// const asyncDispatch = store => next => action => {
// 	let syncActivityFinished = false;
// 	let actionQueue = [];

// 	function flushQueue() {
// 		actionQueue.forEach(a => store.dispatch(a)); // flush queue
// 		actionQueue = [];
// 	}

// 	function asyncDispatch(asyncAction) {
// 		actionQueue = actionQueue.concat([asyncAction]);

// 		if (syncActivityFinished) {
// 			flushQueue();
// 		}
// 	}

// 	const actionWithAsyncDispatch = Object.assign({}, action, { asyncDispatch });

// 	const res = next(actionWithAsyncDispatch);

// 	syncActivityFinished = true;
// 	flushQueue();

// 	return res;
// };

(() => {
	// const middleweare = process.env.__MODE__ === "development" ? [logger, asyncDispatch] : [asyncDispatch];
	const middleweare = process.env.__MODE__ === "development" ? [] : [];

	const actionSanitizer = action => {
		if (action.type === "SET_FLEET" && action.state) {
			return { ...action, state: typeof action.state };
		}

		if (action.type === "SET_STAFF" && action.payload) {
			return { ...action, payload: typeof action.payload };
		}

		if (action.type === "SET_FLIGHTS" && action.flights) {
			return { ...action, flights: typeof action.flights };
		}

		if (action.type === "SET_FLIGHT_PLANS" && action.flightPlans) {
			return { ...action, flightPlans: typeof action.flightPlans };
		}

		return action;
	};

	const stateSanitizer = state => {
		return {
			...state,
			airports: undefined
		};
	};

	const devToolsConfig = { actionSanitizer, stateSanitizer };
	const logRocketConfig = { ...devToolsConfig };
	// const composeEnhancers =
	// 	(window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(devToolsConfig)) ||
	// 	compose;
	const composeEnhancers = compose;

	store = createStore(
		allReducers,
		composeEnhancers(applyMiddleware(...middleweare, LogRocket.reduxMiddleware(logRocketConfig)))
	);
})();

const persistor = persistStore(store);

export default store;
export { store, persistor };
